import { createFileRoute, lazyRouteComponent, redirect } from '@tanstack/react-router';

import { canAccessTerritorySettings } from '&/features/settings/utils/settings-scope-access';

export const Route = createFileRoute('/_authenticated/settings_/territories/$territoryId')({
  beforeLoad: ({ context }): void => {
    if (context.permissions.isReady && !canAccessTerritorySettings(context.permissions)) {
      throw redirect({ to: '/settings' });
    }
  },
  component: lazyRouteComponent(() => import('&/features/settings/territories/pages/territory-detail-page')),
  staticData: { dynamic: true },
});
